import React, {
    useCallback,
    useContext,
    useState
} from "react";
import axios from "axios";
import {
    useHistory
} from "react-router-dom";
import {
    Alert
} from "react-bootstrap";
import {
    Title
} from "@zandor300/backoffice-framework";

import ShopsContext from "../../context/ShopsContext";
import Helmet from "../../components/Helmet";
import CategoryForm from "./components/CategoryForm";
import normalizeCategorySlug from "../../utilities/normalizeCategorySlug";
import handleBackofficeSessionExpired from "../../utilities/handleBackofficeSessionExpired";
import getCategorySaveErrorMessage from "./functions/getCategorySaveErrorMessage";

function NewCategory() {
    const shopsContext = useContext(ShopsContext);
    const history = useHistory();
    const [category, setCategory] = useState({
        title: "",
        slug: "",
        description: ""
    });
    const [slugEditedManually, setSlugEditedManually] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const onChange = useCallback((newState) => {
        const hasOwn = (key) => Reflect.apply(Object.prototype.hasOwnProperty, newState, [key]);
        setCategory((prevState) => {
            const updatedCategory = {
                ...prevState,
                ...newState
            };
            if(hasOwn("title") && !slugEditedManually && !hasOwn("slug")) {
                updatedCategory.slug = normalizeCategorySlug(newState.title);
            }
            return updatedCategory;
        });

        if(hasOwn("slug")) {
            setSlugEditedManually(true);
        }
    }, [slugEditedManually]);

    const onSave = useCallback(async () => {
        if(category.title.trim().length === 0) {
            setError("Titel is vereist.");
            window.scroll({ top: 0, behavior: "smooth" });
            return;
        }
        if(normalizeCategorySlug(category.slug).length === 0) {
            setError("Slug is vereist.");
            window.scroll({ top: 0, behavior: "smooth" });
            return;
        }

        setError(null);
        setLoading(true);

        try {
            const response = await axios.post("/addCategory", {
                shopId: shopsContext.currentShop.id,
                title: category.title.trim(),
                description: category.description,
                slug: category.slug
            });

            if(response.data.valid) {
                history.push("/shop/" + shopsContext.currentShop.codeName + "/category/" + response.data.category.id);
                return;
            }
            if(handleBackofficeSessionExpired(response.data)) {
                return;
            }
            setError(getCategorySaveErrorMessage(response.data.error));
        } catch(requestError) {
            if(handleBackofficeSessionExpired(requestError.response?.data)) {
                return;
            }
            console.error(requestError);
            setError("Er ging iets fout. Probeer het later opnieuw.");
        } finally {
            window.scroll({ top: 0, behavior: "smooth" });
            setLoading(false);
        }
    }, [category, history, shopsContext.currentShop.codeName, shopsContext.currentShop.id]);

    return (
        <React.Fragment>
            <Helmet title="Categorie toevoegen"/>
            <Title preTitle="Overzicht">
                Categorie toevoegen
            </Title>
            { error && (
                <Alert variant="danger">{ error }</Alert>
            )}
            <CategoryForm
                state={ category }
                onChange={ onChange }
                loading={ loading }
                onSave={ onSave }
                submitLabel="Categorie toevoegen"
            />
        </React.Fragment>
    );
}

export default React.memo(NewCategory);
